export default __webpack_public_path__ + "static/media/fof-leadership.fdd998ae.svg";